// Storage base URL:
export const storageUrl =
  'https://storage.act4climate.greentripper.org/gt-uploads/assets/';

export const ONBOARDING_VIDEO_URLS = {
  fr: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/onboarding_fr.mp4',
  en: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/onboarding_en.mp4',
  nl: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/onboarding_en.mp4',
} as const;

export const RESOURCE_URLS = {
  awarenessKit: {
    pdf: {
      fr: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/kit_fr.pdf',
      en: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/kit_en.pdf',
      nl: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/kit_nl.pdf',
      de: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/kit_en.pdf',
    },
    pptx: {
      fr: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/kit_fr.pptx',
      en: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/kit_en.pptx',
      nl: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/kit_nl.pptx',
      de: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/kit_en.pptx',
    },
  },
  caseStudy: {
    pdf: {
      fr: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/case_study_fr.pdf',
      en: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/case_study_en.pdf',
      nl: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/case_study_nl.pdf',
      de: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/case_study_en.pdf',
    },
    pptx: {
      fr: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/case_study_fr.pptx',
      en: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/case_study_en.pptx',
      nl: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/case_study_nl.pptx',
      de: 'https://storage.act4climate.greentripper.org/gt-uploads/assets/case_study_en.pptx',
    },
  },
  whatsNext: {
    pdf: {
      fr: "https://storage.act4climate.greentripper.org/gt-uploads/assets/What's next_fr.pdf",
      en: "https://storage.act4climate.greentripper.org/gt-uploads/assets/What's next_en.pdf",
      nl: "https://storage.act4climate.greentripper.org/gt-uploads/assets/What's next_nl.pdf",
      de: "https://storage.act4climate.greentripper.org/gt-uploads/assets/What's next_en.pdf",
    },
    pptx: {
      fr: "https://storage.act4climate.greentripper.org/gt-uploads/assets/What's next_fr.pptx",
      en: "https://storage.act4climate.greentripper.org/gt-uploads/assets/What's next_en.pptx",
      nl: "https://storage.act4climate.greentripper.org/gt-uploads/assets/What's next_nl.pptx",
    },
  },
} as const;

export const WEBINAR_REGISTRATION_URLS = {
  onboarding: {
    fr: 'https://greentripper.odoo.com/event/onboarding-act4travel-fr-2/register',
    en: 'https://greentripper.odoo.com/event/onboarding-act4travel-en-3/register',
    nl: 'https://greentripper.odoo.com/event/onboarding-act4travel-nl-4/register',
  },
  whatsNext: {
    fr: 'https://greentripper.odoo.com/event/act4travel-whats-next-fr-5/register',
    en: 'https://greentripper.odoo.com/event/act4travel-whats-next-en-6/register',
    nl: 'https://greentripper.odoo.com/event/act4travel-whats-next-nl-7/register',
  },
} as const;

export const LEGAL_MENTION_URLS = {
  termsAndConditions: {
    fr: 'https://cdn.prod.website-files.com/68a43caea7e211563116018b/69de39f8fa6931149e69fbcd_70b8f34f49ca29c5f8bacdc2a0a24ab8_2026_Terms_Service_GreenTripper_fr.pdf',
    en: 'https://cdn.prod.website-files.com/68a43caea7e211563116018b/69de39f84cce4c4c7d7aabe8_0e01ddbddd77bceafd407edd610a14f4_2026_Terms_Service_GreenTripper_en.pdf',
    nl: 'https://cdn.prod.website-files.com/68a43caea7e211563116018b/69de39f83071844d6531fe04_ad2e5bf5736c21b6845a1ed9fcc6acce_2026_Terms_Service_GreenTripper_nl.pdf',
  },
  privacy: {
    fr: 'https://cdn.prod.website-files.com/68a43caea7e211563116018b/69de372825fab0f5d833f1e7_a21a14afc784e2ceeae0ed5f21dd0b43_Privacy_Policy_Greentripper_2026_FR.pdf',
    en: 'https://cdn.prod.website-files.com/68a43caea7e211563116018b/69de3728df043e3059205f92_fb0c3a4d6c75014719fcc014c3a614b7_Privacy_Policy_Greentripper_2026_EN.pdf',
    nl: 'https://cdn.prod.website-files.com/68a43caea7e211563116018b/69de3728f0332c6be2118ad9_cf72ce6e4160c9657a472915516eae9b_Privacy_Policy_Greentripper_2026_NL.pdf',
  },
};
